import { render, staticRenderFns } from "./QuinielaEquipos.vue?vue&type=template&id=ecc0bc3e&lang=pug"
import script from "./QuinielaEquipos.vue?vue&type=script&lang=js"
export * from "./QuinielaEquipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports